import { ILogger } from '@cian/logger/shared';
import { IHttpApi } from '@cian/http-api';

import { createPutReviewModel, TPutReviewRequest } from '../repositories/reviews/v3/put-review';
import { TPutAnswerRequest, createPutAnswerModel } from '../repositories/reviews/v3/put-answer';
import { ICreateEditReviewResponseV3 } from '../repositories/reviews/entities/web_entities/CreateEditReviewResponseV3';
import { ICreateEditAnswerResponseV3 } from '../repositories/reviews/entities/web_entities/CreateEditAnswerResponseV3';
import { IGetReviewsRequest, createGetReviewsModel } from '../repositories/reviews/v2/get-reviews';
import { IGetReviewsResponseV2 } from '../repositories/reviews/entities/web_entities/GetReviewsResponseV2';
import { IErrorResponseSchema } from '../repositories/reviews/entities/schemas/ErrorResponseSchema';

export function getReviews(client: IHttpApi, options: IGetReviewsRequest, logger: ILogger) {
  return client
    .fetch({
      ...createGetReviewsModel(options),
    })
    .then(response => {
      if (response.statusCode !== 200) {
        const message = `Unable to get realtor reviews with id ${options.realtyUserId}.`;
        const errorResponse = response.response as IErrorResponseSchema;
        const error = errorResponse.message;

        const meta = {
          realtorId: options.realtyUserId,
        };

        logger.error(`${message} ${error}`, meta);

        /*
        Если API ответило, но мы отзывы доставить как фичу не можем,
        то валим страницу с ошибкой и логгируем кастомное сообщение.
        Позже сюда подъедет деградация (вместо ошибки отдадим заглушку в стор).
      */
        throw new Error(errorResponse.message);
      }

      return (response.response as IGetReviewsResponseV2).data;
    })
    .catch(error => {
      const message = `Fail to get reviews for realtor with id ${options.realtyUserId}.`;

      const meta = {
        realtorId: options.realtyUserId,
      };

      logger.error(`${message} ${error}`, meta);

      /*
      Если API не ответило вообще, то валим страницу с ошибкой.
    */
      throw new Error(error);
    });
}

export function putReview(client: IHttpApi, options: TPutReviewRequest) {
  return client
    .fetch({
      ...createPutReviewModel(options),
    })
    .then(response => {
      if (response.statusCode !== 200) {
        return response.response;
      }

      return (response.response as ICreateEditReviewResponseV3).data;
    });
}

export function putAnswer(client: IHttpApi, options: TPutAnswerRequest) {
  return client
    .fetch({
      ...createPutAnswerModel(options),
    })
    .then(response => {
      if (response.statusCode !== 200) {
        return response.response;
      }

      return (response.response as ICreateEditAnswerResponseV3).data;
    });
}
